<script setup>
const props = defineProps({
  fillColor: { type: String, default: '#fff' },
})
</script>

<template>
  <svg
    width="39"
    height="48"
    viewBox="0 0 39 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.6355 40.7799H4.38312C2.63337 40.7799 1.20068 39.3472 1.20068 37.5975V13.5701C1.20068 11.8204 2.63337 10.3877 4.38312 10.3877H34.6355C36.3853 10.3877 37.818 11.8204 37.818 13.5701V37.5975C37.818 39.3472 36.3853 40.7799 34.6355 40.7799ZM4.38312 11.3645C3.16592 11.3645 2.17699 12.3534 2.17699 13.5706V37.5979C2.17699 38.8151 3.16595 39.8041 4.38312 39.8041H34.6355C35.8527 39.8041 36.8417 38.8151 36.8417 37.5979V13.5706C36.8417 12.3534 35.8527 11.3645 34.6355 11.3645H4.38312Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M34.6355 40.78H4.38312C2.63337 40.78 1.20068 39.3473 1.20068 37.5975V32.7034H37.8057V37.5975C37.8184 39.3473 36.3856 40.78 34.6359 40.78H34.6355ZM2.1771 33.6797V37.6102C2.1771 38.8274 3.16606 39.8163 4.38323 39.8163H34.6356C35.8528 39.8163 36.8418 38.8273 36.8418 37.6102V33.6797H2.1771Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M19.9914 40.299L19.0151 40.2863L19.0278 38.1436L19.9914 38.1562L19.9914 40.299ZM19.9914 37.0023L19.0151 36.9897L19.0278 34.847L19.9914 34.8596L19.9914 37.0023ZM19.9914 33.6931L19.0151 33.6804L19.0278 31.5377L19.9914 31.5504L19.9914 33.6931ZM19.9914 30.3965L19.0151 30.3838L19.0278 28.2411L19.9914 28.2538L19.9914 30.3965ZM19.9914 27.0872L19.0151 27.0745L19.0278 24.9318L19.9914 24.9445L19.9914 27.0872ZM19.9914 23.7906L19.0151 23.7779L19.0278 21.6352L19.9914 21.6479L19.9914 23.7906ZM19.9914 20.4814L19.0151 20.4687L19.0278 18.326L19.9914 18.3386L19.9914 20.4814ZM19.9914 17.1847L19.0151 17.1721L19.0278 15.0293L19.9914 15.042L19.9914 17.1847ZM19.9914 13.8755L19.0151 13.8628L19.0278 11.7201L19.9914 11.7328L19.9914 13.8755ZM19.9914 10.5789L19.0151 10.5662L19.0278 8.42347L19.9914 8.43615L19.9914 10.5789ZM19.9914 7.26962L19.0151 7.25694L19.0278 5.11422L19.9914 5.1269L19.9914 7.26962ZM19.9914 3.973L19.0151 3.96032L19.0278 2.90796L19.9914 2.92064L19.9914 3.973Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M12.6626 23.5874H13.6389V31.1188H12.6626V23.5874Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M4.73779 18.3003H5.71409V31.1191H4.73779V18.3003Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M8.69482 20.9377H9.67111V31.1064H8.69482V20.9377Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M16.3657 26.2246H17.342V31.106H16.3657V26.2246Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M22.1714 26.2246H23.1477V31.106H22.1714V26.2246Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M25.8755 23.5874H26.8518V31.1188H25.8755V23.5874Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M29.8452 20.9377H30.8215V31.1064H29.8452V20.9377Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M33.8003 18.3003H34.7766V31.1191H33.8003V18.3003Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M8.90164 8.29938C8.81064 8.02385 8.71963 7.72996 8.61044 7.45443C8.50123 7.16054 8.41023 6.86664 8.30102 6.59112H5.22522C5.13422 6.88502 5.02502 7.17891 4.93401 7.47281C4.84301 7.7667 4.73381 8.04223 4.66101 8.31775H2.82275C3.11396 7.45444 3.40517 6.66458 3.65996 5.94828C3.93297 5.21354 4.18778 4.5339 4.44258 3.89101C4.69738 3.24811 4.95219 2.64195 5.1888 2.05407C5.4436 1.48466 5.69841 0.915237 5.95322 0.364258H7.62757C7.88237 0.915304 8.13718 1.48474 8.392 2.05407C8.64681 2.62341 8.90161 3.24803 9.15642 3.89101C9.41124 4.53398 9.66603 5.21354 9.93903 5.94828C10.212 6.68302 10.485 7.47286 10.7762 8.31775H8.90154L8.90164 8.29938ZM6.77218 2.14587C6.73578 2.25608 6.68117 2.42139 6.59016 2.62346C6.51736 2.82551 6.42636 3.04593 6.33537 3.32145C6.24436 3.5786 6.13517 3.8725 6.00775 4.18477C5.88034 4.49704 5.77114 4.82766 5.64374 5.17666H7.90051C7.77311 4.82766 7.6639 4.49702 7.55471 4.18477C7.44551 3.87252 7.3363 3.5786 7.22709 3.32145C7.11788 3.0643 7.02689 2.82551 6.95409 2.62346C6.88129 2.42141 6.82669 2.25609 6.77208 2.14587H6.77218Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.209122"
    />
    <path
      d="M30.954 8.31775C30.5075 8.31775 30.0796 8.2998 29.633 8.28184C29.1865 8.26389 28.74 8.19208 28.2749 8.1023V0.561745C28.647 0.489931 29.0563 0.436071 29.5028 0.418117C29.9493 0.38221 30.3586 0.364258 30.7307 0.364258C31.2517 0.364258 31.7168 0.400165 32.1447 0.471979C32.5726 0.543793 32.9447 0.669463 33.261 0.831049C33.5773 1.01059 33.8191 1.22602 33.9866 1.51327C34.154 1.80053 34.247 2.14164 34.247 2.55459C34.247 3.18295 33.9307 3.66769 33.3168 4.02678C33.8377 4.20632 34.1726 4.47562 34.3586 4.79878C34.5447 5.12193 34.6377 5.481 34.6377 5.89395C34.6377 6.70186 34.3214 7.33023 33.7075 7.74322C33.0749 8.12025 32.1633 8.31773 30.9539 8.31773L30.954 8.31775ZM30.0237 3.48824H30.9168C31.4749 3.48824 31.8656 3.41642 32.1075 3.27279C32.3493 3.12917 32.4609 2.91372 32.4609 2.60851C32.4609 2.28534 32.3307 2.06991 32.0888 1.94423C31.847 1.81854 31.4749 1.74674 30.9912 1.74674H30.4889C30.3028 1.74674 30.154 1.7647 30.0051 1.78265V3.48829L30.0237 3.48824ZM30.0237 4.83475V6.84554C30.154 6.86349 30.3028 6.86349 30.4516 6.88145C30.6005 6.88145 30.7865 6.8994 30.954 6.8994C31.4935 6.8994 31.94 6.82759 32.2749 6.666C32.6098 6.52237 32.7772 6.23512 32.7772 5.84015C32.7772 5.48108 32.6284 5.22972 32.3493 5.06815C32.0702 4.90658 31.6795 4.83475 31.1586 4.83475L30.0237 4.83475Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.209122"
    />
    <path
      d="M19.5087 47.0947C19.2424 47.0947 19.0269 46.8792 19.0269 46.6129V40.2987C19.0269 40.0324 19.2424 39.8169 19.5087 39.8169C19.7749 39.8169 19.9904 40.0324 19.9904 40.2987V46.6129C19.9904 46.8792 19.7749 47.0947 19.5087 47.0947Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M19.5087 47.0947C19.2424 47.0947 19.0269 46.8792 19.0269 46.6129V40.2987C19.0269 40.0324 19.2424 39.8169 19.5087 39.8169C19.7749 39.8169 19.9904 40.0324 19.9904 40.2987V46.6129C19.9904 46.8792 19.7749 47.0947 19.5087 47.0947Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
    <path
      d="M25.7726 47.1072H13.246C12.9797 47.1072 12.7642 46.8916 12.7642 46.6254C12.7642 46.3591 12.9797 46.1436 13.246 46.1436H25.7726C26.0389 46.1436 26.2544 46.3591 26.2544 46.6254C26.2544 46.8916 26.0388 47.1072 25.7726 47.1072Z"
      fill="#667085"
      stroke="#667085"
      stroke-width="0.666667"
    />
  </svg>
</template>
